module.exports = __webpack_public_path__ + "img/gray_notes.5738b3d3.svg";